<template>
    <Modal v-model="show" width="800" title="运送方式(Shipping Method)" :mask-closable="false">
        <div class='shipping-mian'>
            <RadioGroup v-model="store_Id"  size='large' vertical>
                <Radio :label="item.Code" v-for='item in expressList'>
                    <span class='store_text'>
                        {{item.Name}}({{item.NameEn}})
                        
                        {{item.Description}}
                        <!-- <b v-if='item.Description'>{{item.Description}}</b> -->
                    </span>
                    <!-- <span class='store_nameEn'>({{item.NameEn}})</span>
                    <span class='store_desc' v-if='item.Description'>{{item.Description}}</span> -->
                </Radio>
         </RadioGroup>
        <Collapse simple>
        <Panel name="1">
            精油生活馆自提(Essential Oil Life Center pick-up)
            <p slot="content">
                  <RadioGroup v-model="store_Id"  size='large' vertical>
                    <Radio :label="item.Code" v-for='item in pickUpList'>
                        <span class='store_text'>
                            {{item.Name}}({{item.NameEn}})
                            {{item.Description}}
                        </span>
                        <div style='left: 20px;' class='store_text store_text1' v-if='item.Street&&store_Id==item.Code'>{{item.Street}}</div>
                        <!-- <span class='store_nameEn'>({{item.NameEn}})</span>
                        <span class='store_desc' v-if='item.Description'>{{item.Description}}</span> -->
                    </Radio>
                    </RadioGroup>
                   
            </p>
        </Panel>
       
    </Collapse>
        </div>
        <div slot="footer">
            <Button size="large" @click="cancel">取消(cancel)</Button>
            <Button type="primary" size="large"  @click="confirm">确认(confirm)</Button>
        </div>
    </Modal>
</template>
<script>
import {
	    mapState,
	    mapActions,
	    mapMutations,
	    mapGetters
	} from 'vuex';

export default {
	data(){
		return {
            store_Id:'501',
            accordion:false,
            value3:'1'
        }
    },
    computed:{
        ...mapState({
            warehouseInfo: state => state.order.warehouseInfo,
        }),
        warehouseList: function (){
            return [...((this.warehouseInfo || {}).value || {})];
        },
        expressList:function(){
            return this.warehouseList.filter(u=>u.Code=='501')
        },
        pickUpList:function(){
             return this.warehouseList.filter(u=>u.Code!='501')
        }

    },
    props:{
        show:{
            type:Boolean,
            default:false,
        },
        storeId:{
            type:String,
            default:null
        },
        loading:{
            type:Boolean,
            default:false,
        }
    },
   
    watch:{
        storeId:function(value){
            this.store_Id=value;
        },
        show:function(value){
            if(value){
                this.store_Id=this.storeId;
                // let model=$('.shipping-mian .ivu-collapse-item');
                //  if(this.store_Id!='501'){
                //     if(!$(model).hasClass("ivu-collapse-item-active")){
                //         $('.ivu-collapse-header').click()
                //     }
                // }
                // else{
                //     if($(model).hasClass("ivu-collapse-item-active")){
                //         $('.ivu-collapse-header').click()
                //     }
                // }
            }
            else{
                
                this.$emit('cancel')
            }
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.initData();
        })
    },
    methods:{
        ...mapActions([
            'initWarehouseAction'   
        ]),
        initData(){
           
        },
        async confirm(){
          var item=this.warehouseList.filter(u=>u.Code==this.store_Id)[0];
          if(item.Code!='501'){
              
              this.$Modal.confirm({
						title:'多特瑞精油生活馆自提注意事项(Tips)',
						content:'请在下单后14日内前往生活馆自提（周一至周六 10:30-18:30），若超时，系统会自动退货退款。欢迎您即刻开始美好的精油之旅！<br>Please pick up your order within 14 days in the oil store after paid successfully（Monday to Saturday 10:30am-18: 00pm）, Otherwise, the order would be cancelled and refund automatically. Welcome to enjoy your journey of essential oil !',
						okText:'同意，继续结账(Agree, go to pay)',
						cancelText:'不同意，更改运送方式(Disagree, change shipping method)', 
						onOk:()=>{
							 this.$emit('confirm',item);
						}
					});
            
          }
          else{
              this.accordion=false
                this.$emit('confirm',item);
          }
        
        },
        cancel(){
            this.$emit('cancel')
        }
    }
}
</script>
<style lang='scss' >
    .shipping-mian{
         .store_name{
            display: inline-block;
        }
        .store_nameEn{
            display: inline-block;
        }
        .store_desc{
            display: inline-block;
            //float: right;
        }
        .store_text{
            display: flex;
            position: relative;
            top: -7px;
            font-size: 13px;
        }
        .store_text1{
            background-color: #dedede8c;
          
        }
        .ivu-radio{
            float: left;
        }
        .ivu-radio-wrapper{
            white-space:inherit;
            height: inherit;
        }
        .ivu-collapse{
            border: none;
            background-color:white;
        }
        .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header{
            padding-left: 5px;
        }
        .ivu-collapse-content-box{
            padding-top: 5px;
        }
        .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header > i{
                margin-right: 0px;
        }
    }
@media (max-width: 768px){
    .shipping-mian{
        font-size: 0.5rem;
        .store_text{
             font-size: 0.5rem;
        }
    }
    .ivu-modal-header-inner{
         font-size: 0.5rem;
    }
    
}
</style>

    